//// Application Packages
import React from 'react'
import { Link } from 'react-router-dom'

//// Application Slices

//// Carbon Components
import { Button } from '@carbon/react'

//// Application Components

//// Carbon Icons

//// Static Constants

//////// Component
const ButtonComponent = ({ kind, size, title, click, link, payment }) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Button Style Object
    const btnStyObj = {}

    // Button Style - Kind
    if (kind) {
        btnStyObj.kind = kind
    } else {
        btnStyObj.kind = 'primary'
    }

    // Button Style - Size
    if (size) {
        btnStyObj.size = size
    } else {
        btnStyObj.size = 'lg'
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (click && title) {
        return (
            <>
                <Button
                    className="fldoh-btn"
                    onClick={(e) => click(e)}
                    type="button"
                    kind={btnStyObj.kind}
                    size={btnStyObj.size}
                >
                    {title}
                </Button>
            </>
        )
    } else if (link && title) {
        return (
            <>
                <Link to={link}>
                    <Button
                        className="fldoh-btn"
                        type="button"
                        kind={btnStyObj.kind}
                        size={btnStyObj.size}
                    >
                        {title}
                    </Button>
                </Link>
            </>
        )
    } else if (payment && title) {
        return (
            <>
                <Link to={payment} target="_blank" rel="noreferrer noopener">
                    <Button
                        className="fldoh-btn"
                        type="button"
                        kind={btnStyObj.kind}
                        size={btnStyObj.size}
                    >
                        {title}
                    </Button>
                </Link>
            </>
        )
    } else {
        return <></>
    }
}

export default ButtonComponent
